module.exports = __webpack_public_path__ + "img/iconfinder_user.51c10256.svg";